import React, { Dispatch, SetStateAction } from 'react'
import { useSelector } from 'react-redux'
import { selectAddressFormData } from 'slices/addressFormSlice'
import ReportCheckout from '../MapOrReport/ReportCheckout/ReportCheckout'
import MapCheckout from '../MapOrReport/MapCheckout/MapCheckout'
import IndexCheckout from '../Index/IndexCheckout/IndexCheckout'
import ValueCheckout from '../Value/ValueCheckout/ValueCheckout'
import IndexSummary from '../Index/IndexCheckout/IndexSummary'
import MapOrReportSummary from '../MapOrReport/MapOrReportSummary/MapOrReportSummary'
import ValueSummary from '../Value/ValueCheckout/ValueSummary'

export interface ProductCheckoutProps {
  isReportGenerated: boolean
  setReportGenerated: Dispatch<SetStateAction<boolean>>
  onBackdropClick: () => void
  setCurrentTab: Dispatch<SetStateAction<number>>
  setCurrentSubTab: Dispatch<SetStateAction<number>>
  currentSubTab: number
  isModernizationDisabled: boolean
}

const ProductCheckout = (props: ProductCheckoutProps) => {
  const { currentSubTab } = props
  const addressFormData = useSelector(selectAddressFormData)

  if (currentSubTab === 0) {
    switch (addressFormData.productName) {
      case 'report':
        return <MapOrReportSummary {...props} />
      case 'map':
        return <MapOrReportSummary {...props} />
      case 'index':
        return <IndexSummary {...props} />
      case 'value':
        return <ValueSummary {...props} />
      default:
        return <></>
    }
  } else {
    switch (addressFormData.productName) {
      case 'report':
        return <ReportCheckout {...props} />
      case 'map':
        return <MapCheckout {...props} />
      case 'index':
        return <IndexCheckout {...props} />
      case 'value':
        return <ValueCheckout {...props} />
      default:
        return <></>
    }
  }
}

export default ProductCheckout
